var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, EventEmitter, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { FxDapHttpClient } from '../../fx-http-client';
var FxToolBarComponent = /** @class */ (function () {
    function FxToolBarComponent(http, translateService) {
        this.http = http;
        this.translateService = translateService;
        this.programId = '';
        this.btnData = []; //按钮资料\
        this.onButton = new EventEmitter();
        this.currentStyles = {}; //浮层按钮的样式
        this.showBtn = false; //更多按钮显示层
        this.btnMore = []; // 更多按钮
        this.showMoreBtn = false;
    }
    FxToolBarComponent.prototype.ngOnInit = function () {
        this.btnList$ = this.updateButtonList();
    };
    FxToolBarComponent.prototype.ngAfterViewInit = function () {
        // this.reizesWidth();
    };
    FxToolBarComponent.prototype.updateButtonList = function () {
        var _this = this;
        return Observable.create(function (observer) {
            _this.getAuthedButtonList(_this.programId).then(function (lstBtn) {
                var result = _this.btnData.map(function (item) {
                    var index = lstBtn.findIndex(function (btn) { return btn.id === item.id; });
                    return index < 0
                        ? item
                        : Object.assign({}, item, {
                            authed: true,
                            icon: lstBtn[index].icon,
                            name: lstBtn[index].name
                        });
                });
                observer.next(result.filter(function (item) { return item.authed; }));
                observer.complete();
            });
        });
    };
    FxToolBarComponent.prototype.getAuthedButtonList = function (programId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.http.post('A/IACommonService/showButtonDisplay', { param: { program_no: programId } }).toPromise()];
                    case 1:
                        response = _a.sent();
                        if (response.success && response.data) {
                            // return response.data.map(item => {
                            //   return {id: item.abe003, name: item.abe003_n1};
                            // });
                            return [2 /*return*/, response.data.map(function (item) {
                                    return item.icon
                                        ? Object.assign({}, item, { icon: 'anticon ' + item.icon })
                                        : item;
                                })];
                        }
                        else {
                            return [2 /*return*/, []];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    //宽度适应
    FxToolBarComponent.prototype.reizesWidth = function () {
        var _this = this;
        var sum = 0;
        var allW = this.btnW.nativeElement.clientWidth;
        var btnChild = this.btnW.nativeElement.children;
        //console.log(btnChild)
        //console.log(this.btnData)
        var btnsWidth = [];
        for (var i = 0; i < btnChild.length; i++) {
            var w = btnChild[i].clientWidth + 6;
            sum += w;
            btnsWidth.push(w);
        }
        sum += 50;
        if (sum > allW && allW != 0) {
            for (var index = this.btnData.length - 1; index >= 0; index--) {
                //console.log(index, this.btnData[index],'index')
                this.btnMore.splice(0, 0, this.btnData[index]);
                this.btnData.splice(index, 1);
                sum -= btnsWidth[index];
                if (sum < allW) {
                    break;
                }
            }
            setTimeout(function () {
                _this.showMoreBtn = true;
            }, 0);
        }
        //console.log(this.btnData)
        //console.log(this.btnMore)
    };
    //对应的按钮操作
    FxToolBarComponent.prototype.clickFixedBtn = function (name) {
        this.onButton.emit(name);
    };
    FxToolBarComponent.prototype.checkActionDataAurhority = function (action, data, table) {
        var _this = this;
        var postParam = {
            action_list: [action],
            primaryKey_value_map: data,
            program_no: this.programId,
            table_no: table || '',
        };
        return Observable.create(function (observer) {
            _this.http.post('A/IACommonService/chkActionDataAuthority', { param: postParam }).subscribe(function (response) {
                // if (response.success && response.data && response.data.find(item => item === action)) {
                observer.next(response.success && response.data && response.data.find(function (item) { return item === action; }));
                // } else
            }, function (error) {
                observer.next(false);
            }, function () {
                observer.complete();
            });
        });
    };
    return FxToolBarComponent;
}());
export { FxToolBarComponent };
